/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from '../../../../../components';
import {
  SingleQuestionAwareCollapsibleList,
  MultiQuestionsAwareCollapsibleList,
} from '../../../../AwareCollapsibleList';
import {
  criarConfiguracaoCruzamentoSimples,
  atualizarConfiguracaoCruzamentoSimples,
} from '../../../../../stores/actions/simpleCross';
import Loading from '../../../../../components/Loading/loading';
import validateConfig from './simpleCrossConfigValidator';
import * as Ui from './styles';


function SimpleCrossConfig({
  /**
   * Dados da seleção ou extraído do token, no caso de customerId
   */
  customerId,
  /**
   * Id da pesquisa referenciada
   */
  surveyId,
  /**
   * Id da pergunta pricipal referenciada
   */
  questionId,
  /**
   * Enunciado da pergunta principal
   */
  questionTitle,
  /**
   * Indicador se as configuracoes devem ser exibidas
   */
  isOpen = false,
  /**
   * Callback para click de salvar a configuracao
   */
  onSave,
  /**
   * Callback para cancelaamento da configuracao
   */
  onCancel,
  /**
   * Objeto com a configuracao existente do cruzamento, caso exista
   */
  initialData = null,
  /**
   * others props
   */
  ...props
}) {
  // props from redux
  const { isConfigLoading, dispatch, configError } = props;

  // states
  const [alreadySelectedQuestionsId, setAlreadySelectedQuestionsId] = useState(null);
  const [subjected, setSubjected] = useState(false);
  const [errors, setErrors] = useState({ perguntas: [] });
  const [perguntasCruzadas, setPerguntasCruzadas] = useState([]);
  const [showModalActions, setShowModalActions] = useState(true);
  const [hiddenOkButton, sethiddenOkButton] = useState(true);
  const [isUpdate, setIsUpdate] = useState(false);

  // calbacks
  /**
  * Valida e armazena o estado de validacao
  * da configuracao
  */
  const validate = useCallback((crossedQuestions) => {
    const newErrors = validateConfig(crossedQuestions);
    setErrors(newErrors);
    return newErrors;
  }, []);

  /**
   * Limpa os dados de configuracao
   */
  const clearConfig = useCallback((sRef) => {
    setSubjected(false);
    if (sRef && sRef.current) {
      sRef.current.reset();
    }
    setPerguntasCruzadas([]);
  }, []);

  // refs: modal component
  const selectorRef = useRef(null);

  /**
   * Callback executado quando a exibicao do modal de
   * configuracao eh alterada
   */
  useEffect(() => {
    if (!isOpen) return;
    if (alreadySelectedQuestionsId) {
      setPerguntasCruzadas([...alreadySelectedQuestionsId]);
    }
  }, [alreadySelectedQuestionsId, isOpen]);

  /**
   * Callback executado quando os dados do cruzamento
   * pre-existente mudam
   */
  useEffect(() => {
    if (initialData) {
      setIsUpdate(true);
      const mainQuestion = initialData.perguntas_principais[0];
      const idCrossQuestions = mainQuestion.perguntas_cruzadas.map((question) => question.id);
      setAlreadySelectedQuestionsId(idCrossQuestions);
    } else {
      setIsUpdate(false);
      setAlreadySelectedQuestionsId(null);
    }
  }, [initialData]);

  /**
   * Callback executado quando a pergunta principal eh alterada
   */
  useEffect(() => {
    if (questionId) sethiddenOkButton(false);
  }, [questionId]);

  /**
   * Callback executado quando a configuracao eh criada com sucesso
   */
  useEffect(() => {
    /**
     * Caso esteja em carregamento, nao podemos fechar o modal
     */
    if (isConfigLoading) {
      setShowModalActions(false);
    } else {
      setShowModalActions(true);
    }

    /**
     * Caso a configuracao tenha sido criada com sucesso
     */
    if (!isConfigLoading && subjected && !configError) {
      if (!isUpdate) {
        toast.success('Cruzamento criado com sucesso!');
      } else {
        toast.success('Cruzamento atualizado com sucesso!');
      }
      clearConfig(selectorRef);
      setShowModalActions(true);
      onSave();
    }
  }, [clearConfig, configError, isConfigLoading, isUpdate, onSave, subjected]);

  /**
   * Callback executado quando houve um erro
   * na comunicacao com a API
   */
  useEffect(() => {
    if (configError) {
      toast.error(configError.message);
      setShowModalActions(true);
    }
  }, [configError]);

  /**
   * Callback de validacao executado quando o estado da configuracao muda
   */
  useEffect(() => {
    // execute validação
    validate(perguntasCruzadas);
  }, [validate, perguntasCruzadas]);

  /**
   * Callback executado quando o manuseio da
   * configuracao eh cancelado
   */
  function handleModalCancel() {
    onCancel();
    clearConfig(selectorRef);
  }

  /**
   * Quando a configuracao esta valida,
   * eh lancado a requisicao a API e ao mesmo
   * tempo uma action que fica monitorado o
   * estado da mesma
   */
  function submit() {
    const isValidForm = validate(perguntasCruzadas).isValid;

    if (isValidForm) {
      if (!isUpdate) {
        criarConfiguracaoCruzamentoSimples(customerId, surveyId, {
          pergunta_principal: questionId,
          perguntas_cruzadas: perguntasCruzadas,
        }, dispatch);
      } else {
        atualizarConfiguracaoCruzamentoSimples(customerId, surveyId, questionId, {
          perguntas_cruzadas: perguntasCruzadas,
        }, dispatch);
      }
    }
  }

  /**
   * callback executado quando o form
   * de configuracao eh submetido
   */
  function handleModalOk() {
    if (!subjected) setSubjected(true);
    submit();
  }

  function handleSelectQuestions(questionsIds) {
    setPerguntasCruzadas(questionsIds);
  }

  function renderError() {
    return !subjected || errors.questions.length === 0 ? ''
      : errors.questions.map((errorMessage, index) => (
        <span
          className="errorMessage"
          key={`error_pergunta_${index}`}
        >
          {errorMessage}
        </span>
      ));
  }

  function renderLoadingContent() {
    return (
      <div>
        <span className="texto-carregamento">Salvando...</span>
        <Loading size={20} running />
      </div>
    );
  }

  function renderBodyContent() {
    return (
      <div className="config-wrapper">
        <div className="pergunta-principal-wrapper">
          <div className="label-wrapper">
            <span className="label-text">Pergunta principal</span>
          </div>
          <SingleQuestionAwareCollapsibleList
            customerId={customerId}
            surveyId={surveyId}
            questionId={questionId}
            questionTitle={questionTitle}
            checkedTitle
            boldedTitle
            expansible
          />
        </div>
        <div className="selecao-wrapper">
          <MultiQuestionsAwareCollapsibleList
            expansibleItems
            ref={selectorRef}
            customerId={customerId}
            surveyId={surveyId}
            initialSelectedQuestionsIds={perguntasCruzadas}
            label={'Selecione as perguntas que serão cruzadas com a pergunta principal'}
            errorComponent={renderError()}
            inputPlaceholder={'Busque pelo enunciado'}
            onSelectQuestions={handleSelectQuestions}
            questionsToIgnore={[questionId]}
          />
        </div>
      </div>
    );
  }

  function renderContent() {
    return isConfigLoading
      ? renderLoadingContent()
      : renderBodyContent();
  }

  return (
    <div className="config-cruzamento-simples-wrapper">
      <Modal
        isOpen={isOpen}
        title={'Configuração de Cruzamentos Simples'}
        okBtnTitle={'Salvar'}
        cancelBtnTitle={'Voltar'}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
        showActions={showModalActions}
        hiddenOkButton={hiddenOkButton}
      >
        <Ui.Container>
          {!questionId ? (
            <span className="errorMessage">
              Um cruzamento é baseado na pergunta principal, escolha uma e tente novamente
            </span>
          ) : renderContent()}
        </Ui.Container>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  const isConfigLoading = state.simpleCross.configuration.running;
  const configError = state.simpleCross.configuration.error;
  return { isConfigLoading, configError };
};

export default connect(mapStateToProps)(SimpleCrossConfig);
